import { Grid } from '@material-ui/core';
import { GridContentAlignment, GridJustification } from '@material-ui/core/Grid';
import React from 'react';

interface IVerticalCenter {
  justifyContent?: GridJustification;
  alignContent?: GridContentAlignment;
  containerStyle?: React.CSSProperties | undefined;
  containerClass?: string;
  itemStyle?: React.CSSProperties | undefined;
  itemClass?: string;
}

const VerticalCenter: React.FC<IVerticalCenter> = (
  props: React.PropsWithChildren<IVerticalCenter>,
): JSX.Element => {
  return (
    <Grid
      container
      justifyContent={props.justifyContent || 'center'}
      alignContent={props.alignContent || 'center'}
      className={`fullHeight ${props.containerClass}`}
      style={props.containerStyle}
    >
      <Grid item className={props.itemClass} style={props.itemStyle}>
        {props.children}
      </Grid>
    </Grid>
  );
};

export default VerticalCenter;
